// https://github.com/uswds/uswds/blob/v2.8.1/src/js/components/combo-box.js

export const COMBO_BOX_CLASS = `usa-combo-box`;
export const COMBO_BOX_PRISTINE_CLASS = `${COMBO_BOX_CLASS}--pristine`;
export const SELECT_CLASS = `${COMBO_BOX_CLASS}__select`;
export const INPUT_CLASS = `${COMBO_BOX_CLASS}__input`;
export const CLEAR_INPUT_BUTTON_CLASS = `${COMBO_BOX_CLASS}__clear-input`;
export const CLEAR_INPUT_BUTTON_WRAPPER_CLASS = `${CLEAR_INPUT_BUTTON_CLASS}__wrapper`;
export const INPUT_BUTTON_SEPARATOR_CLASS = `${COMBO_BOX_CLASS}__input-button-separator`;
export const TOGGLE_LIST_BUTTON_CLASS = `${COMBO_BOX_CLASS}__toggle-list`;
export const TOGGLE_LIST_BUTTON_WRAPPER_CLASS = `${TOGGLE_LIST_BUTTON_CLASS}__wrapper`;
export const LIST_CLASS = `${COMBO_BOX_CLASS}__list`;
export const LIST_OPTION_CLASS = `${COMBO_BOX_CLASS}__list-option`;
export const LIST_OPTION_FOCUSED_CLASS = `${LIST_OPTION_CLASS}--focused`;
export const LIST_OPTION_SELECTED_CLASS = `${LIST_OPTION_CLASS}--selected`;
export const LIST_OPTION_NO_RESULTS = `${LIST_OPTION_CLASS}--no-results`;
export const STATUS_CLASS = `${COMBO_BOX_CLASS}__status`;
